// extracted by mini-css-extract-plugin
export default {"button":"WagonsFilterButton_button__gFN9n","active":"WagonsFilterButton_active__DIbaR"};